import { call, query } from "./calls";

export const Dashboard = {
    create: (dashboard) => call("/Dashboard", "POST", dashboard),
    update: (dashboard) => call(`/Dashboard/${dashboard.id}`, "PUT", dashboard),
    delete: (id) => call(`/Dashboard/${id}`, "DELETE"),
    get: (id) => call(`/Dashboard/${id}`),
    list: () => query("select * from Dashboard"),
    lightList: () => query("select id, name from Dashboard order by name")
};